import { Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { ResourceConfig } from '../model/resource-config.model';
import { BaseEntity } from '../../domain/base.entity';
import { IAuditConfigLocator } from '../audit.config';
import { fromEvent, Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Directive({
  selector: '[appAuditRouter]'
})
export class AuditRouterDirective implements OnDestroy {
  private auditConfig: ResourceConfig;
  private entity: BaseEntity;
  private clickSubscription: Subscription;

  constructor(
    private readonly templateRef: TemplateRef<void>,
    private readonly viewContainer: ViewContainerRef,
    private readonly router: Router,
    private readonly auditConfigLocator: IAuditConfigLocator
  ) {}

  @Input()
  set appAuditRouter(entity: BaseEntity) {
    this.entity = entity;
    this.auditConfig = this.auditConfigLocator.get(Object.getPrototypeOf(entity).constructor.name);
    this.updateView();
  }

  private updateView(): void {
    if (this.auditConfig != null) {
      const view = this.viewContainer.createEmbeddedView(this.templateRef);
      this.clickSubscription = fromEvent(view.rootNodes[0], 'click').subscribe(() => {
        this.router.navigate([this.routerLink], { queryParams: { returnUrl: this.router.url } }).then();
      });
    } else {
      this.viewContainer.clear();
    }
  }

  get routerLink(): string {
    if (this.auditConfig != null) {
      return `/auditoria/${this.auditConfig.path}/${this.entity.id}`;
    }
    return null;
  }

  ngOnDestroy(): void {
    if (this.clickSubscription != null) {
      this.clickSubscription.unsubscribe();
    }
  }
}
